export default __webpack_public_path__ + "static/media/pm.6c84eae5.svg";